<template>
  <div class="animated fadeIn">
    <customer-card
      v-if="customer"
      :customer="customer"
      :is_form="true"
    />
    <b-form @submit.prevent="onSubmit">
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">{{
            customer
              ? `Update ${customer.short_name} Information`
              : "New Customer"
          }}</span>
        </b-card-header>
        <div class="py-3 px-5">
          <b-form-group label="Short Name" :label-cols="3">
            <b-form-input
              v-model="form_data.short_name"
              :state="!$v.form_data.short_name.$invalid"
              invalid-feedback="Required"
              placeholder="Short Name (Internal use mainly)"
              type="text"
            />
          </b-form-group>
          <b-form-group label="Report Name/ Company Name" :label-cols="3">
            <b-form-input
              v-model="form_data.full_name"
              :state="!$v.form_data.full_name.$invalid"
              invalid-feedback="Required"
              placeholder="Report Name/ Company Name (Reports and printables)"
              type="text"
            />
          </b-form-group>
          <!-- <b-form-group label="Account #" :label-cols="3">
            <b-form-input
              v-model="form_data.account_number"
              :state="!$v.form_data.account_number.$invalid"
              invalid-feedback="Required"
              placeholder="Account #"
              type="text"
            />
          </b-form-group> -->
          <b-form-group
            label="Currently Inactive?"
            :label-cols="3"
          >
            <b-form-checkbox
              v-model="form_data.inactive"
              :value="1"
              :unchecked-value="0"
            />
          </b-form-group>
          <b-form-group
            label="Creditable Account?"
            :label-cols="3"
          >
            <b-form-checkbox
              v-model="form_data.credit"
              :value="1"
              :unchecked-value="0"
            />
          </b-form-group>
        </div>
      </b-card>
      <b-row v-if="!is_customer_form" class="mb-3" align-h="end">
        <b-col lg="2" md="4" sm="12">
          <b-button
            @click="submitForm"
            :disabled="isInvalid"
            block          
            variant="success"
            ><i class="fal fa-address-book" /> Save</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import CustomerCard from "@/components/crm/customer/CustomerCard.vue"
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

export default {
  name: "CustomerForm",
  components: {
    CustomerCard
  },
  mixins: [ validationMixin ],
  props: {
    customer: {
      type: Object,
      default: () => null
    },
    is_customer_form: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form_data: {
        short_name: null,
        full_name: null,
        account_number: null,
        inactive: 0,
        credit: 0
      }
    };
  },
  computed: {
    isInvalid() {
      return this.$v.$invalid;
    }
  },
  validations: {
    form_data: {
      short_name: { required },
      full_name: { required },
      account_number: { required }
    }
  },
  methods: {
    submitForm() {
      this.$emit("submit", this.form_data)
    }
  },
  watch: {
    form_data: {
      handler() {
        this.is_customer_form && this.$emit(
          "updateFormData",
          "customer",
          this.form_data,
          !this.isInvalid
        )
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.customer && (
      this.form_data = {
        ...this.customer.cloneAttributes(true, true, ["id"])
      }
    );
  }
};
</script>
